import { get, values } from 'lodash'
import { createSelector } from 'reselect'

export const getSalesEventTypes = state => values(get(state, 'eventType.byId'))

const getSalesEventType = (state, eventTypeId) => get(state, `eventType.byId.${eventTypeId}`, {})

export const makeGetSalesEventType = () => createSelector([getSalesEventType], (eventType) => eventType)
